import { EnumBuilder, type ZodSimplify } from '@mntn-dev/utility-types'

export const [ChargeProductTypes, ChargeProductTypeSchema] = EnumBuilder(
  'package',
  'add-on'
)

export type ChargeProductType = ZodSimplify<typeof ChargeProductTypeSchema>
